import React, { LegacyRef, useState, useCallback } from 'react';
import { CubeIcon } from '@fronton/icons-react';
import { ThemeProvider } from 'fronton-react';
import {
  ButtonWithGAClickButton,
  MobileFixedPanelModal,
  MobileFixedPanelStructure,
  PanelActionBlock,
  Typography,
} from 'common/components';
import {
  kitchenSignSectionPanel,
  kitchenSignSectionPanelButtons,
  kitchenSignSectionPanelIcon,
  kitchenSignSectionPanelMobileButton,
  kitchenSignSectionPanelText,
  kitchenSignSectionPanelWrapper,
} from './kitchen-sign-section-panel-styles';

type KitchenSignSectionPanelProps = {
  calculatorHref: string;
  elementBlock: string;
  isRuRegion: boolean;
  panelRef: LegacyRef<HTMLDivElement>;
  signUpHref: string;
};

const mobilePanelStructure: MobileFixedPanelStructure = {
  content: {
    icon: CubeIcon,
    iconColor: 'accent-primary',
    iconType: 'duotone',
    text: `Запишитесь на\u00A0проектирование или рассчитайте примерную стоимость кухни в\u00A0нашем калькуляторе`,
  },
  mobileButton: {
    openModal: true,
    label: 'Записаться на проектирование',
  },
  actionBlock: [],
};

export const KitchenSignSectionPanel: React.FC<KitchenSignSectionPanelProps> = ({
  calculatorHref,
  elementBlock,
  isRuRegion,
  panelRef,
  signUpHref,
}) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const handleOpenModal = useCallback(() => {
    setIsModalOpen(true);
  }, []);

  return (
    <ThemeProvider>
      <div ref={panelRef} className={kitchenSignSectionPanelWrapper}>
        <div className={kitchenSignSectionPanel}>
          <CubeIcon
            className={kitchenSignSectionPanelIcon}
            size="40px"
            color="var(--accent-primary)"
            type="duotone"
            strokeWidth={0.5}
          />
          <Typography
            className={kitchenSignSectionPanelText}
            variant="s"
            size="body_short"
            color="text-invert"
          >
            {
              isRuRegion
                ? 'Запишитесь на\u00A0проектирование или рассчитайте примерную стоимость кухни в\u00A0нашем калькуляторе'
                : 'Запишитесь на\u00A0проектирование'
            }
          </Typography>
          <div className={kitchenSignSectionPanelButtons}>
            {isRuRegion && (
              <ButtonWithGAClickButton
                elementBlock={elementBlock}
                elementName="Приезжайте в гости — посмотрите кухни вживую"
                elementText="Узнать цену"
                invert
                variant="pseudo"
                href={calculatorHref}
                target="_blank"
                size="m">
                Узнать цену
              </ButtonWithGAClickButton>
            )}
            <ButtonWithGAClickButton
              elementBlock={elementBlock}
              elementName="Приезжайте в гости — посмотрите кухни вживую"
              elementText="Записаться"
              variant="accent"
              href={signUpHref}
              target="_blank"
              size="m">
              Записаться
            </ButtonWithGAClickButton>
          </div>
        </div>

        <ButtonWithGAClickButton
          className={kitchenSignSectionPanelMobileButton}
          elementBlock={calculatorHref}
          elementName="Приезжайте в гости — посмотрите кухни вживую"
          elementText="Записаться на проектирование"
          variant="accent"
          adaptive={false}
          wide
          onClick={handleOpenModal}>
          Записаться на&nbsp;проектирование
        </ButtonWithGAClickButton>

        <MobileFixedPanelModal
          elementName="Приезжайте в гости — посмотрите кухни вживую"
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          structure={{
            ...mobilePanelStructure,
            actionBlock: [
              ...(
                isRuRegion
                  ? [{
                    elementBlock: elementBlock,
                    href: signUpHref,
                    label: 'Записаться',
                    target: '_blank',
                    variant: 'accent',
                  }] : []
              ) as PanelActionBlock[],
              {
                elementBlock: elementBlock,
                invert: true,
                label: 'Узнать цену',
                variant: 'pseudo',
                href: signUpHref,
                target: '_blank',
              },
            ],
          }}
        />
      </div>
    </ThemeProvider>
  );
};
